import styles from "./MonthChooser.module.css";
import {Button} from "@/components/ui/button";

export interface MonthChooserProps {
  monthYearString: string;
  onPrevMonth: () => void;
  onNextMonth: () => void;
}

const MonthChooser = (props: MonthChooserProps) => {
  const { monthYearString, onNextMonth, onPrevMonth } = props;
  return (
    <div id="minicalendarheader" className={styles.header}>
      <Button
        id="left_arrow"
        onClick={onPrevMonth}
        size="icon-xs"
        variant="ghost"
        aria-label="Mois précédent"
      >
        &#9664;
      </Button>
      <div id="minicalendarmonthyear" className={styles.monthYear}>
        {monthYearString}
      </div>
      <Button
        id="right_arrow"
        onClick={onNextMonth}
        size="icon-xs"
        variant="ghost"
        aria-label="Mois suivant"
      >
        &#9654;
      </Button>
    </div>
  );
};

export default MonthChooser;
